<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d7e205413">Top Ten Quotes about Hinduism </p>
<p class="pub" id="d7e205913"><b>1.</b> “The lower animals are our brethren. I include among them the lion and the tiger. We do not know how to live with these carnivorous beasts and poisonous reptiles because of our ignorance.”—Mohandas K. Gandhi </p>
<p class="pub" id="d9t00213"><b>2.</b> “The fullest life is impossible without an immovable belief in a Living Law in obedience to which the whole universe moves.”—Mohandas K. Gandhi </p>
<p class="pub" id="d9t00413"><b>3.</b> “It is fitting that at this solemn moment we take the pledge of dedication to the service of India and her people and to the still larger cause of human ity.” —Jawaharlal Nehru, Inaugural Address as Prime Minister, August 15, 1947 </p>
<p class="pub" id="d9t00513"><b>4.</b> “The seeker of God is the real lover of vidya, unchangeable truth; all else is avidya, relative knowledge.”—Paramahansa Yogananda </p>
<p class="pub" id="d9t00613"><b>5.</b> “Doubtless, oh great warrior, the mind is difficult to subdue. It is restless all the time. But oh! Son of Kunti, the mind can be conquered by repeated exercises and dispassion to sensual objects.”—Krishna to Arjuna, Bhagavad Gita 6:34 </p>
<p class="pub" id="d9t00813"><b>6.</b> “It made me high. It really did.”—John Lennon, reflecting on cruising the Adriatic Sea while chanting “Hare Krishna” with George Harrison </p>
<p class="pub" id="d9t00913"><b>7.</b> “When a chunk of salt is thrown into water, it dissolves into that very water, and it cannot be picked up in any way. Yet, from whatever place one may take a sip, the salt is there! In the same way, this Immense Being has no limit or boundary and is a single mass of perception.”—Upanishads, 2.4.12</p>
<p class="pub" id="d7e217213"><b>8.</b> “Owing to ignorance of the rope, the rope appears to be a snake; owing to ignorance of the Self, the transient state arises of the individualized, limited, phenomenal aspect of the Self.”—Shankara </p>
<p class="pub" id="d9t01013"><b>9.</b> “By chanting the names of the Lord you will be free/The Lord is awaiting on you all to awaken and see”—George Harrison, “Awaiting on You All”</p>
<p class="pub" id="d7e219813"><b>10.</b> “I believe what it says in the scriptures and in the Bhagavad Gita: ‘Never was there a time when you did not exist, and there never will be a time when you cease to exist.’”—George Harrison </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Anth_9781605507507_epub_c9_r1.vue?fab35b20